__turbopack_context__.v({
  "buttonWrapper": "QuestionnaireFirmAside-module__410MHW__buttonWrapper",
  "customElements": "QuestionnaireFirmAside-module__410MHW__customElements",
  "customElementsButton": "QuestionnaireFirmAside-module__410MHW__customElementsButton",
  "questionnaireFirmAside": "QuestionnaireFirmAside-module__410MHW__questionnaireFirmAside",
  "questionnaireFirmAsidePadding": "QuestionnaireFirmAside-module__410MHW__questionnaireFirmAsidePadding",
});
